import { useEffect, useState } from "react";
import Date from "./Date";
import List from "./List";
import { useAdmin } from "../../../context/admin";
import AdminService from "../../../services/admin.service";
import * as CommonTypes from "../../../types/common.types"
import { useGlobal } from "../../../context/global";

export default function Trips() {
    const { setIsLoading } = useGlobal()
    const {currentDay} = useAdmin()
    const [list, setList] = useState<CommonTypes.TripReservation[]>([])
    useEffect(() => {
        async function getList() {
            setIsLoading(true)
            try {
                if (!currentDay) return
                const response = await (await AdminService.listTripsByDayReservations(currentDay)).data
                console.log(response)
                setList(response)
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
        if (currentDay) getList()
    }, [currentDay])
    return (
        <>
        <Date/>
        <List list={list} setList={setList}/>
        </>
    )
}
